import { createActionCreator } from "deox";
import {
  AreaTypeEnum,
  DropDownCategoryEnumModel,
  ICommonDataModel,
  ICreatedEntityModel,
  ICustomUserDataModel,
} from "../../../types/types";

export const commonDataLoading = createActionCreator("common/loading");
export const commonDataError = createActionCreator(
  "common/loadingError",
  (resolve) => (error: string) => resolve(error)
);

export const commonDataLoaded = createActionCreator(
  "common/loaded",
  (resolve) => (payload: ICommonDataModel) => resolve(payload)
);

export const customUserDataLoading = createActionCreator("custom/loading");
export const customUserDataError = createActionCreator(
  "custom/loadingError",
  (resolve) => (error: string) => resolve(error)
);

export const customUserDataLoaded = createActionCreator(
  "custom/loaded",
  (resolve) => (payload: ICustomUserDataModel) => resolve(payload)
);

export const addCategoryVariablePending = createActionCreator(
  "common/addCatVarPending",

  (resolve) => (category: DropDownCategoryEnumModel) => resolve(category)
);

export const addCategoryVariableFulfilled = createActionCreator(
  "common/categoryVariableCreated",
  (resolve) =>
    (variableId: number, name: string, category: DropDownCategoryEnumModel) =>
      resolve({ variableId, name, category })
);
//
export const addCategoryVariableRejected = createActionCreator(
  "custom/addCategoryVariableError",
  (resolve) => (error: string) => resolve(error)
);

export const deleteCategoryVariablePending = createActionCreator(
  "common/deleteCatVarPending",

  (resolve) => (category: DropDownCategoryEnumModel) => resolve(category)
);

export const deleteCategoryVariableFulfilled = createActionCreator(
  "common/categoryVariableDeleted",
  (resolve) => (variableId: number, category: DropDownCategoryEnumModel) =>
    resolve({ variableId, category })
);

export const deleteCategoryVariableRejected = createActionCreator(
  "custom/deleteCategoryVariableError",
  (resolve) => (error: string) => resolve(error)
);

//update
export const updateCategoryVariablePending = createActionCreator(
  "common/updateCatVarPending",

  (resolve) => (category: DropDownCategoryEnumModel, variableId: number) =>
    resolve({ category, variableId })
);

export const updateCategoryVariableFulfilled = createActionCreator(
  "common/categoryVariableUpdated",
  (resolve) =>
    (variableId: number, name: string, category: DropDownCategoryEnumModel) =>
      resolve({ variableId, name, category })
);

export const updateCategoryVariableRejected = createActionCreator(
  "custom/updateCategoryVariableError",
  (resolve) => (error: string) => resolve(error)
);

//hide
export const hideCategoryVariablePending = createActionCreator(
  "common/hideCatVarPending",

  (resolve) => (category: DropDownCategoryEnumModel, variableId: number) =>
    resolve({ category, variableId })
);

export const hideCategoryVariableFulfilled = createActionCreator(
  "common/hideCategoryVariableFulfilled",
  (resolve) =>
    (
      variableId: number,
      name: string,
      category: DropDownCategoryEnumModel,
      hide: boolean
    ) =>
      resolve({ variableId, name, category, hide })
);

export const hideCategoryVariableRejected = createActionCreator(
  "custom/hideCategoryVariableError",
  (resolve) => (error: string) => resolve(error)
);

// Area Type Preference
export const updateAreaTypePreferencePending = createActionCreator(
  "common/updateAreaTypePreferencePending"
);

export const updateAreaTypePreferenceFulfilled = createActionCreator(
  "common/updateAreaTypePreferenceFulfilled",
  (resolve) => (areaType: AreaTypeEnum) => resolve(areaType)
);

export const updateAreaTypePreferenceRejected = createActionCreator(
  "common/updateAreaTypePreferenceRejected",
  (resolve) => (error: string) => resolve(error)
);

// Duplicate Candidates
export const duplicateCandidatesLoading = createActionCreator(
  "common/duplicateCandidatesLoading"
);

export const duplicateCandidatesLoaded = createActionCreator(
  "common/duplicateCandidatesLoaded",
  (resolve) => (candidates: any[]) => resolve(candidates)
);

export const duplicateCandidatesError = createActionCreator(
  "common/duplicateCandidatesError",
  (resolve) => (error: string) => resolve(error)
);

export const resolveDuplicateCandidatePending = createActionCreator(
  "common/resolveDuplicateCandidatePending",
  (resolve) => (duplicateCandidateId: number) => resolve(duplicateCandidateId)
);

export const resolveDuplicateCandidateFulfilled = createActionCreator(
  "common/resolveDuplicateCandidateFulfilled",
  (resolve) => (duplicateCandidateId: number) => resolve(duplicateCandidateId)
);

export const resolveDuplicateCandidateRejected = createActionCreator(
  "common/resolveDuplicateCandidateRejected",
  (resolve) => (error: string) => resolve(error)
);

export const mergeCreatedEntities = createActionCreator(
  "common/mergeCreatedEntities",
  (resolve) => (payload: ICreatedEntityModel) => resolve(payload)
);
